import React, { JSX } from 'react';

import { ErrorTag } from '@eika/tag';

interface ErrorMessageLabelProps {
    errorMessage: string | undefined;
    errorId: string;
}

const ErrorMessageLabel = ({ errorMessage, errorId }: ErrorMessageLabelProps): JSX.Element => {
    return (
        <ErrorTag className="sgw-radio-button-error-label" id={errorId}>
            {errorMessage}
        </ErrorTag>
    );
};

export default ErrorMessageLabel;
